<!-- Botón flotante para abrir el chat -->
@if (!isChatOpen()) {
<button class="chatbot-fab" (click)="openChat()" [attr.aria-label]="'CHATBOT.OPEN' | translate">
    <img src="../../../assets/images/chatbot.png" alt="Chatbot" />
</button>
}

<!-- Overlay oscuro -->
<div class="chatbot-overlay" [class.visible]="isChatOpen()" (click)="closeChat()"></div>

<!-- Panel lateral (sidebar) -->
<div class="chatbot-sidebar" [class.open]="isChatOpen()">
    <div class="sidebar-header">
        <span class="close-button" (click)="closeChat()">✕</span>
    </div>

    <div class="messages" #messagesContainer (click)="onMessagesClick($event)">
        @for (message of messages(); track $index) {
        <div class="message-bubble" [ngClass]="{ bot: message.sender === 'bot', person: message.sender === 'person' }">
            @if (message.sender === 'person') {
            <img class="avatar" src="../../../assets/images/person_bubble.png" alt="Usuario" />
            }
            @if (message.sender === 'bot') {
            <img class="avatar" src="../../../assets/images/chatbot_bubble.png" alt="Bot" />
            }
            <div class="message-text" [ngClass]="{ 'person-message': message.sender === 'person' }">
                @if (message.sender === 'person') {
                {{ message.message }}
                } @else {
                <markdown [data]="message.message"></markdown>
                }
            </div>
        </div>
        }
    </div>

    <!-- Contenedor inferior que agrupa botones + input -->
    <div class="chat-footer">
        @if (botOpciones().length || hasSelectedPueblo()) {
        <div class="messages-buttons">
            @if (hasSelectedPueblo()) {
            <button class="option-pill back-pill" (click)="goBackToPueblos()">
                {{'CHATBOT.BACK_TOWNS' | translate}}
            </button>
            }
            @for (opt of botOpciones(); track $index) {
            <button class="option-pill" (click)="userInput.set(opt); sendMessage()">
                {{ opt }}
            </button>
            }
            <button class="option-pill free-search-pill" [class.active]="freeSearchEnabled()"
                (click)="toggleFreeSearch()">
                {{'CHATBOT.FREE_SEARCH' | translate}}
            </button>
        </div>
        }

        <input #chatInput type="text" class="messages-input" [placeholder]="'CHATBOT.PLACEHOLDER' | translate"
            [ngModel]="userInput()" (ngModelChange)="onUserInputChange($event)" (keydown.enter)="sendMessage()"
            [disabled]="botOpciones().length > 0 && !freeSearchEnabled()" />
    </div>
</div>